import styled from "styled-components";

export const Form = styled.form``;

export const DragDropSpace = styled.div`
  width: 100%;
  > div {
    display: flex;
    flex-direction: column;
    gap: 0.1rem;
    background-color: transparent;
    justify-content: center;
    height: auto;
    border-radius: 4px;
    align-items: center;
    color: #f5f5f5;
    margin-top: 1rem;
  }
  .drop-space {
    border: 3px dashed;
    display: flex;
    gap: 0.4rem;
    height: 25vh;
    svg {
      font-size: 3rem;
    }
    button {
      position: relative;
      label {
        cursor: pointer;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
      }
    }
  }
  .image-preview {
    > div:first-of-type {
      ::after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: #00000010;
        transition: background 0.3s;
      }
      position: relative;
      .preview {
        display: none;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 2;
        color: #fff;
        cursor: pointer;
        svg {
          font-size: 2rem;
        }
      }

      :hover {
        .preview {
          display: block;
        }
        ::after {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: #00000069;
        transition: background 0.3s;
        }
      }
    }
    img {
      max-width: 160px;
      object-fit: cover;
    }
  }
  .image-preview-settings {
    display: flex;
    align-items: center;
    color: #d32f2f;
    padding: 0;
    svg {
      cursor: pointer;
      font-size: 1.85rem;
      transition: color 0.2s;
      :hover {
        transition: color 0.2s;
      }
    }
  }
`;

export const ModalStyle = styled.div`
  padding: 2rem;
  width: 100%;
  height: 100%;
  background-color: transparent;
  display: flex;
  justify-content: center;
  @keyframes fadeInScale {
    from {
      opacity: 0;
      transform: scale(0.9);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    animation: fadeInScale 0.5s;
  }
`;
